"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { candidateGroupTableColumn } from "./CandidateGroupTableRows";
import {
  addAllPageItems,
  addSelected,
  removeAllSelectedItems,
  removeSelected
} from "../Components/GenericTable/tableHelper";
const PROGRESS_STEP = 0.5;
const incrementProgress = (state, payload) => {
  const newProgress = Math.min(state.progress + PROGRESS_STEP, payload.targetProgress);
  return __spreadProps(__spreadValues({}, state), { progress: newProgress });
};
const startSearch = (state, payload) => {
  const { typesToExpand } = payload;
  return __spreadProps(__spreadValues({}, state), {
    showResults: false,
    progressVisible: true,
    progress: 0,
    fetchingAssessedPercentage: false,
    typesToExpand,
    totalSteps: typesToExpand.length + 3
  });
};
const completeExecutingSearch = (state) => {
  const { totalSteps } = state;
  const progress = (totalSteps - 2) * 100 / totalSteps;
  return __spreadProps(__spreadValues({}, state), {
    showResults: true,
    fetchingAssessedPercentage: true,
    optionsCleared: false,
    progress
  });
};
const completeAssessingCandidates = (state) => {
  return __spreadProps(__spreadValues({}, state), {
    fetchingAssessedPercentage: false,
    progressVisible: false,
    progress: 100
  });
};
export const InitialCandidatesState = {
  snackbar: {
    message: "",
    state: "success"
  },
  candidatesTableState: {
    canScroll: [false, true],
    tableHovered: false,
    density: "Default",
    columns: candidateGroupTableColumn,
    selectedItemIds: [],
    selectedItems: [],
    actions: {
      selectedItem: null,
      anchorEl: null,
      isOpen: {
        delete: false,
        edit: false
      }
    },
    modalsOpen: { edit: false }
  },
  candidatesTableSettings: {
    page: Number(sessionStorage.getItem(`candidatesTablePage`)) || 1,
    limit: 10,
    sort: "firstname",
    sort_order: "asc"
  },
  searchQuery: "",
  totalPages: 0,
  candidatesCount: 0,
  optionsCleared: false,
  isJobDialogOpen: false,
  typesToExpand: [],
  progress: 0,
  currentStep: "",
  totalSteps: 1,
  transitioningStep: false,
  progressVisible: false,
  fetchingAssessedPercentage: false,
  showResults: true,
  isAddToCandidatePoolOpen: false
};
export const CandidatesReducer = (state, action) => {
  switch (action.type) {
    case "SET_SNACKBAR":
      return __spreadProps(__spreadValues({}, state), { snackbar: action.payload });
    case "SET_SEARCH_QUERY":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableSettings: __spreadProps(__spreadValues({}, state.candidatesTableSettings), { page: 1 }),
        searchQuery: action.payload
      });
    case "SET_DENSITY":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadProps(__spreadValues({}, state.candidatesTableState), {
          density: action.payload
        })
      });
    case "SET_CAN_SCROLL":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadProps(__spreadValues({}, state.candidatesTableState), {
          canScroll: action.payload
        })
      });
    case "SET_TABLE_HOVERED":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadProps(__spreadValues({}, state.candidatesTableState), {
          tableHovered: action.payload
        })
      });
    case "SET_SORT":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableSettings: __spreadProps(__spreadValues({}, state.candidatesTableSettings), {
          sort: action.payload.sortBy,
          sort_order: action.payload.sortOrder
        })
      });
    case "SET_PAGE":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableSettings: __spreadProps(__spreadValues({}, state.candidatesTableSettings), {
          page: action.payload
        })
      });
    case "SET_LIMIT":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableSettings: __spreadProps(__spreadValues({}, state.candidatesTableSettings), {
          limit: action.payload
        })
      });
    case "SELECT_ACTION_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadProps(__spreadValues({}, state.candidatesTableState), {
          actions: __spreadProps(__spreadValues({}, state.candidatesTableState.actions), {
            selectedItem: action.payload.item,
            anchorEl: action.payload.anchorEl,
            isOpen: __spreadProps(__spreadValues({}, state.candidatesTableState.actions.isOpen), {
              [action.payload.name]: true
            })
          })
        })
      });
    case "ADD_SELECTED_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadValues(__spreadValues({}, state.candidatesTableState), addSelected(
          state.candidatesTableState.selectedItems,
          state.candidatesTableState.selectedItemIds,
          action.payload
        ))
      });
    case "REMOVE_SELECTED_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadValues(__spreadValues({}, state.candidatesTableState), removeSelected(
          state.candidatesTableState.selectedItems,
          state.candidatesTableState.selectedItemIds,
          action.payload
        ))
      });
    case "ADD_ALL_PAGE_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadValues(__spreadValues({}, state.candidatesTableState), addAllPageItems(state.candidatesTableState.selectedItems, action.payload))
      });
    case "REMOVE_ALL_PAGE_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadValues(__spreadValues({}, state.candidatesTableState), removeAllSelectedItems(
          state.candidatesTableState.selectedItems,
          state.candidatesTableState.selectedItemIds
        ))
      });
    case "CLOSE_ACTION_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        candidatesTableState: __spreadProps(__spreadValues({}, state.candidatesTableState), {
          actions: __spreadProps(__spreadValues({}, state.candidatesTableState.actions), {
            selectedItem: null,
            isOpen: __spreadProps(__spreadValues({}, state.candidatesTableState.actions.isOpen), {
              [action.payload]: false
            }),
            anchorEl: null
          })
        })
      });
    case "SET_TOTAL_PAGES":
      return __spreadProps(__spreadValues({}, state), { totalPages: action.payload });
    case "SET_CANDIDATES_COUNT":
      return __spreadProps(__spreadValues({}, state), { candidatesCount: action.payload });
    case "SET_PROGRESS":
      return __spreadProps(__spreadValues({}, state), { progress: action.payload });
    case "SET_OPTIONS_CLEARED":
      return __spreadProps(__spreadValues({}, state), { optionsCleared: action.payload });
    case "SET_JOB_DIALOG_OPEN":
      return __spreadProps(__spreadValues({}, state), { isJobDialogOpen: action.payload });
    case "SET_TYPES_TO_EXPAND":
      return __spreadProps(__spreadValues({}, state), { typesToExpand: action.payload });
    case "SET_CURRENT_STEP":
      return __spreadProps(__spreadValues({}, state), { currentStep: action.payload });
    case "SET_TRANSITIONING_STEP":
      return __spreadProps(__spreadValues({}, state), { transitioningStep: action.payload });
    case "SET_PROGRESS_VISIBLE":
      return __spreadProps(__spreadValues({}, state), { progressVisible: action.payload });
    case "SET_FETCHING_ASSESSED_PERCENTAGE":
      return __spreadProps(__spreadValues({}, state), { fetchingAssessedPercentage: action.payload });
    case "INCREMENT_PROGRESS":
      return incrementProgress(state, action.payload);
    case "START_SEARCH":
      return startSearch(state, action.payload);
    case "COMPLETE_EXECUTING_SEARCH":
      return completeExecutingSearch(state);
    case "COMPLETE_ASSESSING_CANDIDATES":
      return completeAssessingCandidates(state);
    case "OPEN_ADD_TO_POOL_DIALOG":
      return __spreadProps(__spreadValues({}, state), { isAddToCandidatePoolOpen: true });
    case "CLOSE_ADD_TO_POOL_DIALOG":
      return __spreadProps(__spreadValues({}, state), { isAddToCandidatePoolOpen: false });
    default:
      return state;
  }
};
